module.exports = __webpack_public_path__ + "img/motorway_10x3_z18.f8e810f6.svg";